export function scrollToNthHighlight(
  container: HTMLElement,
  index: number
): number {
  const emElements = Array.from(container.querySelectorAll('em')).filter(
    (el): el is HTMLElement => el instanceof HTMLElement
  );

  if (emElements.length === 0) return index;

  index = index % emElements.length;

  const el = emElements[index];
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });

  el.classList.add('highlight-scroll');
  setTimeout(() => el.classList.remove('highlight-scroll'), 1500);

  return index + 1;
}

export function scrollToFirstHighlight(container: HTMLElement): void {
  const el = container.querySelector('em');
  if (!(el instanceof HTMLElement)) return;

  el.scrollIntoView({ behavior: 'smooth', block: 'center' });

  el.classList.add('highlight-scroll');
  setTimeout(() => el.classList.remove('highlight-scroll'), 1500);
}
